import { render, staticRenderFns } from "./client_index.vue?vue&type=template&id=cbb74134&"
import script from "./client_index.vue?vue&type=script&lang=js&"
export * from "./client_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports